(ns rlws.iot-cloud.frontend.subscriptions
  (:require
   clojure.set
   [re-frame.core :as rf]
   [rlws.iot-cloud.frontend.authorization :as authz]
   [rlws.iot-cloud.frontend.site :as site]
   [rlws.iot-cloud.frontend.assets.logic :as logic]
   [rlws.iot-cloud.frontend.config :as config]
   [tick.alpha.api :as t]
   [tick.format :as tf]
   [tick.locale-en-us]
   [potpuri.core :as potpuri]
   [clojure.string :as str]))

(t/format :iso-zoned-date-time (t/zoned-date-time))

(rf/reg-sub
 :db
 (fn [db _] db))

(rf/reg-sub
 :debug?
 (fn [db _] (:debug? db)))

(rf/reg-sub
 :dev-options?
 (fn [db _] (:dev-options? db)))

(rf/reg-sub
 :highlight-js-loaded?
 (fn [db _] (:highlight-js-loaded? db)))

(rf/reg-sub
 :modal
 (fn [db _] (:modal db)))

(rf/reg-sub
 :show-menu?
 (fn [db _] (:show-menu? db)))

(rf/reg-sub
 :global-messages
 (fn [db _]
   (:global-messages db)))

(rf/reg-sub
 :settings-popover
 (fn [db _] (:settings-popover db)))

(rf/reg-sub
 :entered
 (fn [db [_ key]] (get-in db [:entered key])))

(rf/reg-sub
 :loading?
 (fn [db _] (:loading? db)))

(rf/reg-sub
 ::current-route
 (fn [db _]
   (:current-route db)))

(rf/reg-sub
 ::customer-tab
 (fn [db _]
   (:customer-tab db :sites)))

(rf/reg-sub
 ::site-tab
 (fn [db _]
   (:site-tab db :site-assets)))

(rf/reg-sub
 ::site-asset-tab
 (fn [db _]
   (:site-asset-tab db "")))

(rf/reg-sub
 ::site-iqube-tab
 (fn [db _]
   (:site-iqube-tab db "")))

(rf/reg-sub
 ::asset-tab
 (fn [db _]
   (:asset-tab db :history)))

(rf/reg-sub
 ::dialog
 (fn [db _]
   (:dialog db :close)))

(rf/reg-sub
 ::selected-gateway
 (fn [db _] 
   (:selected-gateway db "")))

(rf/reg-sub
 ::current-status
 (fn [db _]
   (:current-status db nil)))

(rf/reg-sub
 ::current-scale-status
 (fn [db _] 
   (:current-scale-status db)))

(rf/reg-sub
 ::current-scale
 (fn [db _] 
   (:current-scale db)))

(rf/reg-sub
 ::current-scale-timeout
 (fn [db _] 
   (:current-scale-timeout db)))

(rf/reg-sub
 ::current-scale-temporary-timeout
 (fn [db _] 
   (:current-scale-temporary-timeout db)))

(rf/reg-sub
 ::current-scale-temporary-checkbox
 (fn [db _] 
   (:current-scale-temporary-checkbox db)))

(rf/reg-sub
 ::submitting-notifications
 (fn [db _]
   (:submitting-notifications db)))

(rf/reg-sub
 ::live-cells
 (fn [db _]
   (:live-cells db)))

(rf/reg-sub
 ::live
 (fn [db _]
   (:live db)))

(rf/reg-sub
 ::selected-scale-type
 (fn [db _] 
   (:selected-scale-type db "")))

(rf/reg-sub
 ::selected-scale-dealership
 (fn [db _]
   (:selected-scale-dealership db "")))

(rf/reg-sub
 ::page
 :<- [::current-route]
 (fn [current-route _]
   (get-in current-route [:data :name])))

(rf/reg-sub
 ::page-title
 :<- [::current-route]
 (fn [current-route _]
   (get-in current-route [:data :link-text])))

(rf/reg-sub
 ::path-params
 (fn [_ _]
   (rf/subscribe [::current-route]))
 (fn [current-route _]
   (get current-route :path-params)))

(rf/reg-sub
 ::query-params
 (fn [_ _]
   (rf/subscribe [::current-route]))
 (fn [current-route _]
   (get current-route :query-params)))

(rf/reg-sub
 ::data
 (fn [db [_ & ks]] 
   (let [data (get-in db (potpuri/conjv ks :ajax-data))]
     (if (vector? data)
       (filterv (fn [{:crux.db/keys [id]}]
                  (if id
                    (str/starts-with? id config/site-api-origin)
                    true))
                data)
       data))))

(defn process-user
  [user]
  (-> user
      site/walk-plain-ids
      (clojure.set/rename-keys {:assignee :roles})
      (update :roles (partial map (comp site/to-plain-id :role)))))

(rf/reg-sub
 ::users
 :<- [::data :users]
 (fn [users]
   (->> users
        (map process-user)
        (remove (fn [user]
                  (or (contains? (set (:roles user)) "service")
                      (not (contains? user :dealership))))))))

(rf/reg-sub
 ::user
 (fn [db _]
   (:user db)))

(defn assoc-with
  [m k f]
  (assoc m k (f m)))

(defn format-date
  [s]
  (t/format (tf/formatter "dd MMM yyyy HH:mm:ss")
            (t/date-time (t/instant s))))

(rf/reg-sub
 ::asset
 :<- [::data :asset]
 :<- [::data :images]
 (fn [[asset images]]
   ;; Here we can handle both legacy images in the component data and nested in
   ;; the asset document

   ;; TODO: Remove legacy image handling once no more assets have legacy nested
   ;; images
   (let [update-image (fn [{:keys [image] :as component}]
                        (if image
                          (update component
                                  :image
                                  (fn [image]
                                    (or (get images image)
                                        {:data image})))
                          component))]
     (when (and asset images)
       (update asset
               :components
               (partial map update-image))))))

(rf/reg-sub
 ::current-user
 :<- [::data :current-user]
 :<- [::data :dealerships]
 (fn [[current-user dealerships] _]
   (assoc-with (process-user current-user)
               :permissions
               authz/permissions)))

(rf/reg-sub
 ::brand-logo
 (fn [{:keys [brand-logo]} _]
   brand-logo))

(rf/reg-sub
 ::service-notes
 :<- [::data :service-notes]
 :<- [::data :current-user]
 :<- [::users]
 :<- [::complete-assets]
 (fn [[service-notes current-user users assets]_]
   (let [assets-by-id (potpuri/index-by site/to-plain-id assets)
         username (:username current-user)
         users-by-username (potpuri/index-by :username users)]
     (->> service-notes
          (sort-by #(t/instant (:timestamp %)) >)
          (map (fn [note]
                 (-> note
                     (assoc
                      :editable? (= username (:created-by note)))
                     (update :cell #(or % 0))
                     (update :asset assets-by-id)
                     (update :created-by users-by-username))))))))

(rf/reg-sub
 ::documents
 (fn [db _]
   (let [account-name (get-in db [:user :name])
         service-notes (get-in db [:ajax-data :service-notes])]
     (->> service-notes
          (sort-by #(t/instant (:timestamp %)) >)
          (map (fn [note]
                 (assoc note
                        :timestamp (format-date (:timestamp note))
                        :editable? (= account-name (:author note)))))))))

(rf/reg-sub
  ::complete-alerts
  (fn [[_ asset-id]]
    [(if asset-id
       (rf/subscribe [::data :alerts asset-id])
       (rf/subscribe [::data :all-alerts]))
     (rf/subscribe [::complete-assets])])
  (fn [[alerts assets] [_ asset-id]]
    (let [assets-by-id (potpuri/index-by site/to-plain-id assets)]
      (for [alert (sort-by #(t/instant (:timestamp %)) > alerts)]
        (update alert :asset assets-by-id)))))

(rf/reg-sub
 ::complete-assets
 :<- [::data :assets]
 :<- [::data :customers]
 :<- [::data :dealerships]
 :<- [::data :current-user]
 :<- [::live-assets]
 :<- [::dialog]
 (fn [[assets customers dealerships user live-assets dialog] _] 
   (let [customers-by-id (potpuri/index-by site/to-plain-id customers)
         dealerships-by-id (potpuri/index-by site/to-plain-id dealerships)
         watched-assets (:watched-assets user)] 
       (for [asset assets]
         (if (= dialog :close)
         (let [asset-id (:crux.db/id asset)
               status (logic/asset-status asset live-assets)]
           (-> asset
               (assoc :status status)
               (update :dealership dealerships-by-id)
               (update :customer customers-by-id)
               (update :watched (fn [_]
                                  (some #(= % asset-id)
                                        watched-assets)))))
           asset)))))

(rf/reg-sub
  ::assets-under-watch
  :<- [::complete-assets]
  (fn [assets _]
    (filter :watched assets)))

(rf/reg-sub
 ::scales-under-watch
 :<- [::complete-scales]
 (fn [scales _]
   (filter :watched scales)))

(rf/reg-sub 
 ::live-assets 
 (fn [db _] 
   (:live-assets db)))

(rf/reg-sub
 ::live-gateways
 (fn [db _]
   (:live-gateways db)))

(rf/reg-sub
 ::customer-assets
 :<- [::complete-assets]
 (fn [assets [_ k]] 
   (filter #(= k (site/to-plain-id (:customer %))) assets)))

(rf/reg-sub
 ::site-assets
 :<- [::complete-assets]
 (fn [assets [_ k]] 
   (filter #(= k (site/to-plain-id (:site %))) assets)))

(rf/reg-sub
 ::current-asset
 :<- [::asset]
 :<- [::data :customers]
 (fn [[asset customers]_]
   (when asset
     (let [customer-id (:customer asset)
           customer (potpuri/find-first
                     customers
                     #(= customer-id (site/to-plain-id %)))]
       (merge
        {:customer customer}
        {:raw-data (update asset :components vec)
         :id (site/to-plain-id asset)
         :basic-info (merge {:company (:company customer)}
                            (select-keys asset [:name
                                                :category
                                                :location
                                                :images]))
         :components (vec (sort-by first (:components asset)))})))))

(defn match-cells
  "Matches stored cells with incoming cells from the gateway, we prioritize
  the order and data of incoming cells and add details from stored cells where
  possible"
  [stored-cells gateway-cells]
  (let [indexed-stored-cells (potpuri/index-by :cell-number stored-cells)]
    (reduce (fn [result {:keys [number] :as cell-status}]
              (conj result [cell-status (get indexed-stored-cells number)]))
            []
            gateway-cells)))

;; The asset status combines live data with data stored in crux
;; Also perform some calculations for values like "percentage of full load"
;; asset is stored data, status is live data

(rf/reg-sub
 ::asset-status
 :<- [::asset]
 :<- [::data :status]
 :<- [::dialog]
 (fn [[asset status-payload dialog] _]
   (if (= dialog :close)
     (let [stored-cells (->> asset
                             :components
                             (filter (potpuri/where-fn {:component-type "cell"})))
           [timestamp status] status-payload
           gateway-cells (:load-cells status)
           scale-weight (:weight status)
           load-cells
           (for [[cell-status cell-details]
                 (match-cells stored-cells gateway-cells)
                 :let [{:keys [weight] :as live-cell} cell-status
                       full-load-perc (when (and (pos-int? scale-weight)
                                                 (pos-int? weight))
                                        (/ weight scale-weight))
                       cell-dia-status (-> (potpuri/find-first
                                            (get-in status [:status :cells])
                                            {:cell-number (:number cell-status)})
                                           :capability
                                           keyword)]]
             (merge cell-details
                    cell-status
                    {:status (or cell-dia-status :ok)
                     :full-load-perc (* full-load-perc 100)}))]
       (when (and timestamp status)
         (merge status
                {:load-cells load-cells
                 :last-updated (format-date timestamp)}))))))

(rf/reg-sub
 ::gateway-status
 :<- [::asset]
 :<- [::live-gateways]
 (fn [[asset live-gateways] _]
   (let [asset-id (site/to-plain-id asset)]
     (some? (get live-gateways asset-id)))))

(rf/reg-sub
 ::device-command
 (fn [db [_ asset-id]]
   (get-in db [:device-command asset-id])))

(rf/reg-sub
 ::camera-command
 (fn [db [_ asset-id]]
   (get-in db [:camera-command asset-id])))

(rf/reg-sub
 ::complete-customers
 :<- [::data :customers]
 :<- [::data :dealerships]
 (fn [[customers dealerships] _]
   (let [dealerships-by-id (potpuri/index-by site/to-plain-id dealerships)]
     (for [customer customers]
       (-> customer
           (update :dealership dealerships-by-id))))))

(rf/reg-sub
 ::complete-sites
 :<- [::data :sites]
 (fn [sites [_ k]] 
   (filter #(= k (site/to-plain-id (:customer %))) sites)))

(rf/reg-sub
 ::customer-iqubes
 :<- [::data :iqubes]
 (fn [iqubes [_ k]]
   (filter #(= k (site/to-plain-id (:customer %))) iqubes)))

(rf/reg-sub
 ::site-iqubes
 :<- [::complete-iqubes]
 (fn [iqubes [_ k]]
   (filter #(= k (site/to-plain-id (:site %))) iqubes)))

(rf/reg-sub
 ::customer-scales
 :<- [::data :scales]
 (fn [scales [_ k]]
   (filter #(= k (site/to-plain-id (:customer %))) scales)))

(rf/reg-sub
 ::site-scales
 :<- [::complete-scales]
 (fn [scales [_ k]]
   (filter #(= k (site/to-plain-id (:site %))) scales)))

(rf/reg-sub
 ::complete-iqubes
 :<- [::data :iqubes]
 (fn [iqubes [_ k]] 
   iqubes))

(rf/reg-sub
 ::sites
 :<- [::data :sites]
 (fn [sites [_ k]]
   sites))


(rf/reg-sub
 ::complete-scales
 :<- [::data :scales]
 :<- [::data :current-user] 
 :<- [::data :iqubes]
 :<- [::data :customers]
 :<- [::live-assets]
 (fn [[scales user iqubes customers live-assets] _]
   (let [watched-assets (:watched-assets user)]
     (for [scale scales]
       (let [iqube (first (filterv #(= (site/to-plain-id %) (:iqube scale)) iqubes))
             status (logic/asset-status (str (:gateway scale) " " (:number scale) " " (:ip iqube)) live-assets)]
         (-> scale
             (assoc :status status)
             (update :watched (fn [_]
                                (some #(= % (str (:gateway scale) " " (:number scale) " " (:ip iqube)))
                                      watched-assets)))))))))

(rf/reg-sub
 ::customizations
 :<- [::data :current-user]
 :<- [::data :dealerships]
 (fn [[current-user dealerships] _]
   (let [dealerships-by-id (potpuri/index-by site/to-plain-id dealerships)]
     (when (and current-user (some? dealerships-by-id))
       (or (:customization (get dealerships-by-id (:dealership current-user)))
           {})))))

;; Load cells

(rf/reg-sub
  ::load-cells
  :<- [::data :assets]
  :<- [::live-assets]
  :<- [::data :customers]
  (fn [[assets live-assets customers] _]
    (let [customers-by-id (potpuri/index-by site/to-plain-id customers)]
      (for [{:keys [gateway] :as asset} assets
            {:keys [cell-number component-type] :as cell} (:components asset)
            :when (= component-type "cell")
            :let [{:keys [cells]} (get live-assets gateway)]]
        (-> cell
            (assoc  :asset (-> asset
                               (select-keys [:name :customers :gateway :customer])
                               (update :customer customers-by-id))
                    :status (or (-> cells
                                    (potpuri/find-first {:cell-number cell-number})
                                    :capability
                                    keyword)
                                :ok)))))))

(rf/reg-sub
  ::emulated-load-cells
  :<- [::load-cells]
  (fn [load-cells _]
    (filter (potpuri/where-fn {:status :emulation}) load-cells)))
